var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Header, HeaderText } from './Modal.styled';
import { isNotNilOrEmpty } from '@pcty/utils';
var VERSION = '5.9.0';
/** DISPLAY NAME: &lt;Modal.Header&gt; */
var ModalHeader = function (_a) {
    var automationId = _a.automationId, children = _a.children, title = _a.title, _b = _a.__TYPE, __TYPE = _b === void 0 ? 'ModalHeader' : _b, other = __rest(_a, ["automationId", "children", "title", "__TYPE"]);
    return (React.createElement(Header, { "data-automation-id": automationId },
        isNotNilOrEmpty(title) && React.createElement(HeaderText, null, title),
        React.createElement(React.Fragment, null, children)));
};
ModalHeader.defaultProps = {
    __TYPE: 'ModalHeader',
};
export default ModalHeader;
